import { Ticker } from "@/components/widgets/Ticker/Ticker";
import { useTabs } from "@/context/tabs/TabsContext";
import { DEFAULT_STATE_VALUES } from "@/shared/constants/common";
import type { ViewId } from "@/shared/types/common";

type Props = {
	tileId: string;
	onChange: (id: string, value: string) => void;
};

export const NewsTicker: React.FC<Props> = ({ tileId, onChange }) => {
	const { getWidgetState } = useTabs();
	const state = getWidgetState(tileId as ViewId);
	const ticker = state?.ticker ?? DEFAULT_STATE_VALUES.ticker;

	return (
		<Ticker ticker={ticker} onChange={(value) => onChange(tileId, value)} />
	);
};
